import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {appInjector} from "../../appInjector";
import {ToolsService} from "../../../services/toolsService/tools.service";
import {CesiumAdapterService} from "../../../services/cesiumAdapter21/cesium-adapter.service";
import {ObjectConfig} from "../../../models/ObjectConfig";
import {debounceTime} from "rxjs/operators";

interface Config {
  max: number,
  min: number,
  height: number,
  width: number
}

export class ObjectZoomPlugin extends AbstractMainPlugin{

  private view;
  private isInZoom = false;

  constructor(item:Item) {
    super(item);
    this.initProviders();
    this.initListeners()
  }

  private initProviders(){
    this.view = appInjector.get(CesiumAdapterService);
  }

  private isInConfigZoom(zoomLevel: number, config: Config){
    if (!zoomLevel || !config){
      return false;
    }
    return zoomLevel >= config.min && zoomLevel <= config.max;
  }

  private initListeners(){
      this.view.zoom.pipe(debounceTime(500)).subscribe((zoomLevel)=>{
        let tool = this.item.config.getTool();
        let zoomConfig = null;
        this.isInZoom = false;

        if (tool.type != ObjectConfig.TYPE_FIXED_FIGURE){
          return;
        }

        if (tool.hasOwnProperty('zoom_config') && tool.zoom_config){
            zoomConfig = eval(tool.zoom_config);


          for (let i = 0; i < zoomConfig.length; i++){
            let config:Config = zoomConfig[i];

            if (this.isInConfigZoom(zoomLevel, config)){
              this.setObjectSize(config);
              this.isInZoom = true;
            }
          }

          if (!this.isInZoom){
            this.setDefaultObjectSize(tool);
          }
        }
      })
  }

  private setObjectSize(config: {width, height}){
    this.item.config.getObjectConfig().setData('fixed_width', config.width);
    this.item.config.getObjectConfig().setData('fixed_height', config.height);
  }

  private setDefaultObjectSize(tool){
    if (tool.params){
      if (tool.params.hasOwnProperty('fixedHeight')){
        this.item.config.getObjectConfig().setData('fixed_height', tool.params['fixedHeight'].value);
      }
      if (tool.params.hasOwnProperty('fixedWidth')){
        this.item.config.getObjectConfig().setData('fixed_width', tool.params['fixedWidth'].value);
      }
    }
    else{
      this.setObjectSize({width: tool.fixed_width_meters, height:tool.fixed_height_meters});
    }
  }
}
